import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import material from './material';
import RelateReview from './relate-review.vue';
import ReviewForm from './reviewForm.vue';
import ReviewResult from './review-result.vue';
import { isPlayable as _isPlayable, remarkOptions, materialGrading } from './review.js';
import { reviewMixin } from './mixin/mixin.js';
import AdvertiserSelector from '@/components/AllAdvertiserSelector/index.vue';
import AccountMgrSelector from '@/components/AccountMgrSelector/index.vue';
import _ from 'lodash';

export default {
  mixins: [reviewMixin],

  props: {
    material: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tabName: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    relateList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    currentDcoList: [Array],
    hideAuditDialog: {
      type: Function,
      default: function _default() {}
    },
    pmId: {
      type: Number,
      default: 0
    },
    advId: {
      type: Number,
      default: 0
    },
    machineAudit: {
      type: Object
    }
  },

  components: {
    material: material,
    ReviewForm: ReviewForm,
    RelateReview: RelateReview,
    ReviewResult: ReviewResult
  },

  data: function data() {
    return {
      form: {
        review_opinion: '',
        reason_ids: [],
        reason_text: '',
        adv_tracking_link: '',
        ad_rule_text: ''
      },

      createdDemandStatus: 0,
      list: [],
      loading: false,
      model: {
        adv_id: '',
        pm_id: ''
      },
      formsModel: {
        remark: [],
        material_grading: []
      },
      formConfig: {
        // labelPosition: 'bottom'
        labelWidth: '120px'
      }
    };
  },


  computed: {
    isPlayable: function isPlayable() {
      return _isPlayable(this.material.creative_type);
    },


    // 广告主提供素材
    isAdvMaterial: function isAdvMaterial() {
      return this.material.creative_from === 1;
    },
    isNeedToCreateDemand: function isNeedToCreateDemand() {
      return this.isAdvMaterial && this.isPlayable && this.form.review_opinion === 3 && !this.material.demand_id && this.tabName !== 'Re-Review（巡审）';
    },
    submitButtonAttrs: function submitButtonAttrs() {
      return {
        type: 'primary',
        loading: this.saving
      };
    },
    schema: function schema() {
      return {
        type: 'object',
        properties: {
          adv_id: {
            title: '广告主名称：',
            visible: this.advId === 0,
            component: AdvertiserSelector,
            rules: [{
              required: true,
              message: '请输入广告主名称',
              trigger: 'change'
            }],
            field: {
              clearable: true,
              placeholder: '请输入广告主名称'
            }
          },
          pm_id: {
            title: '需求AM：',
            visible: this.pmId === 0,
            component: AccountMgrSelector,
            rules: [{
              required: true,
              message: '请输入需求AM',
              trigger: 'change'
            }],
            field: {
              clearable: true,
              placeholder: '请输入需求AM'
            }
          }
        }
      };
    },
    formsShema: function formsShema() {
      return {
        type: 'object',
        properties: {
          remark: {
            title: '备注：',
            component: 'checkbox-group',
            field: {
              options: remarkOptions
            }
          },
          material_grading: {
            title: '素材分级：',
            component: 'select',
            field: {
              clearable: true,
              multiple: true,
              'collapse-tags': true,
              placeholder: '请选择素材分级',
              options: materialGrading
            },
            rules: [{
              required: true,
              message: '请选择素材分级'
            }]
          }
        }
      };
    }
  },

  watch: {
    visible: function visible(val) {
      this.$refs && this.$refs.form && this.$refs.form.resetFields();
      this.$refs && this.$refs.form && this.$refs.formRef.resetFields();
      this.createdDemandStatus = 0;
      this.formsModel.remark = [];
      this.formsModel.material_grading = [];
      if (val === true) {
        this.form.adv_tracking_link = this.material.adv_tracking_link;
      }
    }
  },

  mounted: function mounted() {
    this.form.adv_tracking_link = this.material.adv_tracking_link;
  },


  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var validate, formValidate;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                validate = true;

                if (!_this.isNeedToCreateDemand) {
                  _context.next = 6;
                  break;
                }

                _context.next = 5;
                return _this.$refs['demand-form'].validate();

              case 5:
                validate = _context.sent;

              case 6:
                _context.next = 8;
                return _this.$refs['formRef'].validate();

              case 8:
                formValidate = _context.sent;

                if (validate && formValidate) {
                  _this.handleSubmitClick();
                }
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 12]]);
      }))();
    },
    cookSubmitParams: function cookSubmitParams() {
      var reasonIds = _.sortBy(this.form.reason_ids, function (value) {
        return value;
      }).join(',');
      var params = {
        status: this.form.review_opinion
      };

      var reason_text = {};
      // 是否有其他拒绝原因
      var hasOtherReason = this.form.reason_ids.some(function (item) {
        return item === 99;
      });
      if (hasOtherReason) {
        reason_text['99'] = this.form.reason_text;
      }
      // 是否有不合法广告要求
      var hasAdReason = this.form.reason_ids.some(function (item) {
        return item === 8;
      });
      if (hasAdReason) {
        reason_text['8'] = this.form.ad_rule_text;
      }
      if (hasOtherReason || hasAdReason) params.reason_text = reason_text;
      if (reasonIds) params.reason_ids = reasonIds;

      // 备注
      if (this.formsModel && this.formsModel.remark.length) {
        params.remark = this.formsModel.remark;
      }
      // 素材分级
      if (this.formsModel && this.formsModel.material_grading.length) {
        params.material_grading = this.formsModel.material_grading.join();
      }
      return params;
    },
    setVideoCurrentTime: function setVideoCurrentTime(time) {
      if (this.$refs.materialRef.$el.querySelector('video')) {
        this.$refs.materialRef.$el.querySelector('video').currentTime = time;
      }
    }
  }
};